var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcInfoFilledPurple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2C625C29-D60A-494D-8352-4C1B5EE95877") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Misc",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Toast",
    transform: "translate(-120.000000, -654.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(108.000000, 642.000000)",
    id: "icon/ic-info-filled"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,1.66666667 C5.4,1.66666667 1.66666667,5.4 1.66666667,10 C1.66666667,14.6 5.4,18.3333333 10,18.3333333 C14.6,18.3333333 18.3333333,14.6 18.3333333,10 C18.3333333,5.4 14.6,1.66666667 10,1.66666667 Z",
    id: "Path",
    fill: "#6E6CB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,9.16666667 C10.4602373,9.16666667 10.8333333,9.53976271 10.8333333,10 L10.8333333,13.3333333 C10.8333333,13.7935706 10.4602373,14.1666667 10,14.1666667 C9.53976271,14.1666667 9.16666667,13.7935706 9.16666667,13.3333333 L9.16666667,10 C9.16666667,9.53976271 9.53976271,9.16666667 10,9.16666667 Z M10,5.83333333 C10.4602373,5.83333333 10.8333333,6.20642938 10.8333333,6.66666667 C10.8333333,7.12690396 10.4602373,7.5 10,7.5 C9.53976271,7.5 9.16666667,7.12690396 9.16666667,6.66666667 C9.16666667,6.20642938 9.53976271,5.83333333 10,5.83333333 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInfoFilledPurple);
export default __webpack_public_path__ + "static/media/ic-info-filled-purple.9d7feff925000396393980db87994064.svg";
export { ForwardRef as ReactComponent };